import { AppBar, Box, Button, IconButton, Menu, Toolbar, Typography } from '@mui/material';
import React from 'react';
import { NavLink } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import logo from '../../../images/logo.png';
import './Navigation.css'

const Navigation = () => {
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };

    const handleMobileMenuOpen = (event) => {
        setMobileMoreAnchorEl(event.currentTarget);
    };

    const mobileMenuId = 'primary-search-account-menu-mobile';
    const renderMobileMenu = (
        <>
            {/* Navigation For Mobile Device */}
            <Menu
                anchorEl={mobileMoreAnchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                className={mobileMenuId}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={isMobileMenuOpen}
                onClose={handleMobileMenuClose}
            >
                {/* Nav */}
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', pb: 2 }}>
                    <NavLink to="/" style={{ textDecoration: 'none', textAlign: 'center', fontSize: 18, fontWeight: 'bold', fontFamily: "'Open Sans', sans-serif", color: 'black', margin: '10px 0', padding: '0 25px' }}>Home</NavLink>
                    <NavLink to="/about" style={{ textDecoration: 'none', textAlign: 'center', fontSize: 18, fontWeight: 'bold', fontFamily: "'Open Sans', sans-serif", color: 'black', margin: '10px 0', padding: '0 25px' }}>About</NavLink>
                    <NavLink to="/services" style={{ textDecoration: 'none', textAlign: 'center', fontSize: 18, fontWeight: 'bold', fontFamily: "'Open Sans', sans-serif", color: 'black', margin: '10px 0', padding: '0 25px' }}>Services</NavLink>
                    <NavLink to="/trust_us" style={{ textDecoration: 'none', textAlign: 'center', fontSize: 18, fontWeight: 'bold', fontFamily: "'Open Sans', sans-serif", color: 'black', margin: '10px 0', padding: '0 25px' }}>Why Trust Us</NavLink>
                    <NavLink to="/our_work" style={{ textDecoration: 'none', textAlign: 'center', fontSize: 18, fontWeight: 'bold', fontFamily: "'Open Sans', sans-serif", color: 'black', margin: '10px 0', padding: '0 25px' }}>Our Work</NavLink>
                </Box>
            </Menu>
        </>
    );
    return (
        <Box sx={{ flexGrow: 1, backgroundColor: '#ffffff', mx: '3%' }}>
            <AppBar sx={{ boxShadow: 0 }} position="sticky" style={{ backgroundColor: '#ffffff' }}>
                <Toolbar sx={{ display: 'flex', alignItems: 'flex-center' }}>
                    {/* name */}
                    <NavLink to="/" >
                        <img style={{ width: '190px' }} src={logo} alt="" />
                    </NavLink>

                    {/* Right Nav */}
                    <Box sx={{ flexGrow: 1 }} />
                    <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center' }}>
                        <Typography variant="h6" component="h6" id="font-handel">
                            <NavLink to="/"
                                style={({ isActive }) => {
                                    return {
                                        display: "block",
                                        padding: '65px 6px 3px 10px',
                                        textDecoration: 'none',
                                        fontSize: 20,
                                        fontWeight: isActive ? "600" : "400",
                                        color: '#000D83',
                                        fontFamily: "'Open Sans', sans-serif",
                                        backgroundColor: isActive ? "#F7F7FF" : "",
                                        transform: 'skew(0deg, -6deg) translateY(-40px)'
                                    };
                                }}><p id="transform-design">Home</p></NavLink>
                        </Typography>
                        <Typography variant="h6" component="h6" id="font-handel">
                            <NavLink to="/about"
                                style={({ isActive }) => {
                                    return {
                                        display: "block",
                                        padding: '65px 6px 3px 10px',
                                        textDecoration: 'none',
                                        fontSize: 20,
                                        fontWeight: isActive ? "600" : "400",
                                        color: '#000D83',
                                        fontFamily: "'Open Sans', sans-serif",
                                        backgroundColor: isActive ? "#F7F7FF" : "",
                                        transform: 'skew(0deg, -6deg) translateY(-40px)'
                                    };
                                }}><p id="transform-design">About</p></NavLink>
                        </Typography>
                        <Typography variant="h6" component="h6" id="font-handel">
                            <NavLink to="/services"
                                style={({ isActive }) => {
                                    return {
                                        display: "block",
                                        padding: '65px 6px 3px 10px',
                                        textDecoration: 'none',
                                        fontSize: 20,
                                        fontWeight: isActive ? "600" : "400",
                                        color: '#000D83',
                                        fontFamily: "'Open Sans', sans-serif",
                                        backgroundColor: isActive ? "#F7F7FF" : "",
                                        transform: 'skew(0deg, -6deg) translateY(-40px)'
                                    };
                                }}><p id="transform-design">Services</p></NavLink>
                        </Typography>
                        <Typography variant="h6" component="h6" id="font-handel">
                            <NavLink to="/trust_us"
                                style={({ isActive }) => {
                                    return {
                                        display: "block",
                                        padding: '65px 6px 3px 10px',
                                        textDecoration: 'none',
                                        fontSize: 20,
                                        fontWeight: isActive ? "600" : "400",
                                        color: '#000D83',
                                        fontFamily: "'Open Sans', sans-serif",
                                        backgroundColor: isActive ? "#F7F7FF" : "",
                                        transform: 'skew(0deg, -6deg) translateY(-40px)'
                                    };
                                }}><p id="transform-design">Why Trust Us</p></NavLink>
                        </Typography>
                        <Typography variant="h6" component="h6" id="font-handel">
                            <NavLink to="/our_work"
                                style={({ isActive }) => {
                                    return {
                                        display: "block",
                                        padding: '65px 6px 3px 10px',
                                        textDecoration: 'none',
                                        fontSize: 20,
                                        fontWeight: isActive ? "600" : "400",
                                        color: '#000D83',
                                        fontFamily: "'Open Sans', sans-serif",
                                        backgroundColor: isActive ? "#F7F7FF" : "",
                                        transform: 'skew(0deg, -6deg) translateY(-40px)'
                                    };
                                }}><p id="transform-design">Our Work</p> </NavLink>
                        </Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', border: '1px solid #FF2D33', borderRadius: '2px' }}>
                            <Button sx={{ textDecoration: 'none', fontSize: '13px', lineHeight: '15px', color: "#FF2D33", fontWeight: 'bold', width: '134px', height: '36px', }} style={{ textTransform: 'capitalize' }} id="button-hover">
                                Get A Quote
                            </Button>
                        </Box>
                    </Box>

                    <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            onClick={handleMobileMenuOpen}
                        >
                            <MenuIcon sx={{ color: '#000D83' }} />
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>
            {renderMobileMenu}
        </Box >
    );
};

export default Navigation;